import React, { memo } from 'react';
import { string, func, shape } from 'prop-types';
import Close from '@material-ui/icons/Close';
import { UTLabel } from '@widergy/energy-ui';
import { connect } from 'react-redux';
import Error from '@material-ui/icons/Error';

import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';

import styles from './styles.module.scss';

const AlertCard = ({ title, content, onClose, action, dispatch, Icon }) => {
  const handleClick = () => action.onClick(dispatch);

  const IconToRender = Icon || Error;

  return (
    <div className={styles.alertCardContainer}>
      <div className={styles.errorContainer}>
        <IconToRender className={styles.icon} />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.textContainer}>
          <UTLabel white large semibold>
            {title}
          </UTLabel>
          <UTLabel white light>
            {content}
          </UTLabel>
        </div>
        {action && (
          <UTTouchableWithoutFeedback className={styles.newClaimContainer} onClick={handleClick}>
            <UTLabel white light className={styles.newClaimButton}>
              {action.label}
            </UTLabel>
          </UTTouchableWithoutFeedback>
        )}
      </div>
      <UTTouchableWithoutFeedback onClick={onClose} className={styles.closeContainer}>
        <Close className={styles.icon} />
      </UTTouchableWithoutFeedback>
    </div>
  );
};
AlertCard.propTypes = {
  title: string,
  content: string,
  onClose: func,
  action: shape({
    onClick: func,
    label: string
  }),
  Icon: func
};

export default connect()(memo(AlertCard));
